/**
 * Reconcilia el importe mostrado por bicicleta con el total de la reserva y los accesorios cobrados.
 * Corrige el caso en que VehicleRental.subtotal es solo base imponible y el total de reserva incluye IVA por líneas.
 * En el detalle de reserva del admin el subtotal de vehículos usa la suma de `rental.subtotal` cuando es > 0;
 * si no, `booking.vehiclesTotal` y en último término esta reconciliación (reservas sin líneas o legacy).
 */
export function sumAccessoryFinalPrices(vehicleRentals) {
  return (vehicleRentals || []).reduce(
    (s, vr) =>
      s + (vr.accessories || []).reduce((a, x) => a + (Number(x.finalPrice) || 0), 0),
    0
  );
}

export function reconcileVehicleLinePrices(booking, vehicleRentals) {
  const sumAcc = sumAccessoryFinalPrices(vehicleRentals);
  const delivery = Number(booking.deliveryCost) || 0;
  const discount = Number(booking.discount) || 0;
  const totalNum = Number(booking.total) || 0;
  const poolVehicles = Math.round((totalNum - sumAcc - delivery + discount) * 100) / 100;
  const vRentals = vehicleRentals || [];
  const sumSub = vRentals.reduce((s, vr) => s + (Number(vr.subtotal) || 0), 0);
  const n = vRentals.length || 1;
  const prices = vRentals.map((vr) => {
    const sub = Number(vr.subtotal) || 0;
    if (sumSub > 0) {
      return Math.round((poolVehicles * (sub / sumSub)) * 100) / 100;
    }
    return Math.round((poolVehicles / n) * 100) / 100;
  });
  let allocated = 0;
  for (let i = 0; i < prices.length - 1; i++) allocated += prices[i];
  if (prices.length > 0) {
    prices[prices.length - 1] = Math.round((poolVehicles - allocated) * 100) / 100;
  }
  return { prices, poolVehicles, sumAcc };
}
